import {
  defaultInitialState,
  defaultFetchRequestState,
  defaultFetchReceiveSuccessState,
  defaultFetchReceiveErrorState,
  defaultSubmitRequestState,
  defaultSubmitReceiveSuccessState,
  defaultSubmitReceiveErrorState,
} from "shared/redux-store/defaultAppReducerParts";

export default function orderUnitWizardAppReducer(
  state = defaultInitialState(),
  action,
) {
  switch (action.type) {
    case "FETCH_ORDER_UNIT_WIZARD_PRODUCTS_PENDING":
      return {
        ...state,
        ...defaultFetchRequestState(state, action),
      };
    case "FETCH_ORDER_UNIT_WIZARD_PRODUCTS_FULFILLED":
      return {
        ...state,
        ...defaultFetchReceiveSuccessState(state, action, ["products"]),
      };
    case "FETCH_ORDER_UNIT_WIZARD_PRODUCTS_REJECTED":
      return {
        ...state,
        ...defaultFetchReceiveErrorState(state, action),
      };
    case "LOCAL_ORDER_UNIT_WIZARD_PRODUCTS":
      return {
        ...state,
        localData: {
          ...state.localData,
          orderUnit: {
            ...(state.localData ? state.localData.orderUnit : {}),
            orderUnitsProducts: action.orderUnitsProducts,
            products: action.products,
          },
        },
      };
    case "SUBMIT_ORDER_UNIT_WIZARD_PENDING":
      return {
        ...state,
        ...defaultSubmitRequestState(state, action),
      };
    case "SUBMIT_ORDER_UNIT_WIZARD_FULFILLED":
      return {
        ...state,
        ...defaultSubmitReceiveSuccessState(state, action, ["orderUnit"]),
      };
    case "SUBMIT_ORDER_UNIT_WIZARD_REJECTED":
      return {
        ...state,
        ...defaultSubmitReceiveErrorState(state, action),
      };
    default:
      return state;
  }
}
